import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";
import IdleIcon from "../assets/icons/idle-folder.svg";
import ActiveIcon from "../assets/icons/active-folder.svg";
import { LockedAnchor } from ":src/components/overlays";
import { global } from ":shared/app";
export default function Workshops(props: _Navigation.SideNavJSXItemProps) {
  const $settings = global.store.hooks.platform.useSettings("workshops");
  return (
    <Anchor
      class={`relative  ${props?.anchor?.class}`}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      events={{
        getShouldNavigate: () => !$settings().locked,
      }}
      triggers={{
        onBeforeNavigate: () => {
          if ($settings().locked) {
            global.store.actions.toast.pushToast({
              type: "error",
              message: "This page is locked by admin, you can't access it right now!",
            });
          }
        },
      }}
      components={{
        title: "Workshops",
        idleIcon: <i class="i-grommet-icons:workshop w-24px h-24px" />,
        activeIcon: <i class="i-grommet-icons:workshop w-24px h-24px" />,
      }}
    >
      <LockedAnchor locked={$settings().locked} />
    </Anchor>
  );
}
